import logo from './logo.svg';
import './App.css';
import Header from './Components/Layout/Header';
import React from 'react'
import Meals from './Components/Meals/Meal';
import Cart from './Components/Cart/Cart';
import { useState } from 'react';
import CartProvider from './store/CartProvider';

function App() {
  const [showncart,setshowncart] = useState(false)

  const showncarthandler =()=> {
      console.log("button is clicked")
      setshowncart(true)
      console.log(showncart)
  };
  const dontshowcarthandler = ()=>{
    setshowncart(false)
  }
  return (
    
      
      <CartProvider>
      {showncart?<Cart onClose={dontshowcarthandler}/>:""}
       <Header onShowCart={showncarthandler}/>
       <main>
        <Meals/>
       </main>
      </CartProvider>
     
    
  );
}

export default App;
